/**
 * Status, filter, and display config for activity types.
 */
import { CheckCircle2, XCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { BadgeVariant } from '@/components/common/LabelBadge';

/** Badge + icon config for an activity-type status. */
export interface ActivityTypeStatusConfig {
  label: string;
  icon: LucideIcon;
  badgeVariant: BadgeVariant;
  badgeColor?: string;
}

/** Badge config for each activity-type status. */
export const ACTIVITY_TYPE_STATUS_CONFIG: Record<string, ActivityTypeStatusConfig> = {
  active: {
    label: 'Actif',
    icon: CheckCircle2,
    badgeVariant: 'active',
  },
  inactive: {
    label: 'Inactif',
    icon: XCircle,
    badgeVariant: 'outlined',
    badgeColor: 'rgb(var(--color-error))',
  },
};

/** Activity-type list filter state. */
export interface ActivityTypeFilters {
  statuses: string[];
  searchQuery?: string;
}

/** Default activity-type list filters. */
export const DEFAULT_ACTIVITY_TYPE_FILTERS: ActivityTypeFilters = {
  statuses: [],
  searchQuery: '',
};

/** Filter group IDs for the activity-types {@link DataTable} configure panel. */
export type FilterGroupId = 'filter-status' | 'filter-search';

/** Configure-panel order for activity-type filter groups. */
export const ALL_FILTER_GROUP_IDS: FilterGroupId[] = ['filter-status', 'filter-search'];

/** Human-readable label per filter group (configure panel). */
export const FILTER_GROUP_LABELS: Record<FilterGroupId, string> = {
  'filter-status': 'Statut',
  'filter-search': 'Recherche',
};

/** Returns the badge color name for an activity type status. */
export function getActivityTypeStatusColor(status: string): 'success' | 'error' {
  return status === 'active' ? 'success' : 'error';
}

/** Empty create form — status defaults to `active`. */
export const DEFAULT_CREATE_ACTIVITY_TYPE_FORM = {
  code: '',
  label: '',
  description: '',
  status: 'active' as const,
};
